import { Outlet } from 'react-router-dom'

export const CommercialControlRoot = () => {
    return <Outlet />
}
